/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateBusinessBillingBody
 */
export interface UpdateBusinessBillingBody {
    /**
     * 
     * @type {string}
     * @memberof UpdateBusinessBillingBody
     */
    stripeAccountId: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateBusinessBillingBody
     */
    currency: string;
}

export function UpdateBusinessBillingBodyFromJSON(json: any): UpdateBusinessBillingBody {
    return UpdateBusinessBillingBodyFromJSONTyped(json, false);
}

export function UpdateBusinessBillingBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateBusinessBillingBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'stripeAccountId': json['stripeAccountId'],
        'currency': json['currency'],
    };
}

export function UpdateBusinessBillingBodyToJSON(value?: UpdateBusinessBillingBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'stripeAccountId': value.stripeAccountId,
        'currency': value.currency,
    };
}


